import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    name: 'CmgRetroCreditMessage'
})
export default class CmgRetroCreditMessage extends Vue {

    mounted() {
        this.$services.ui.nextFocus('points-title');
    }
}
